import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[data-dismiss]'
})
export class DataDismissDirective {

  constructor(private el: ElementRef) { }

    @HostListener('click', ['$event']) onClick($event){
        $($event.target).parents(".modal").eq(0).hide();
        $($event.target).parents("body").removeClass("modal-open");
    }
}
